import { useCallback, useMemo } from 'react';
import _ from 'lodash';
import { useAppDispatch, useAppSelector } from '../types/hooks';
import { mapFilterValues } from '../store/slices/map';
import { getDevicesCombined } from '../store/actions/deviceActions';
// import { getAllGeofences } from '../store/actions/geofenceActions';
// import { getAllPois } from '../store/actions/poiActions';
// import { getNotifications } from '../store/actions/notificationActions';

const DEBOUNCE_INTERVAL = 950;

export type SocketMessage = {
    event: string;
    action: string;
};

export const useAblyMessageListener = (pathname: string) => {
    const d = useAppDispatch();

    const { mapFilters } = useAppSelector((s) => s.map);

    const [minifinderF, teamF] = useMemo(() => {
        return [mapFilters.includes(mapFilterValues.minifinder), mapFilters.includes(mapFilterValues.team)];
    }, [mapFilters]);

    const getDevicesWithThrottle = useCallback(
        _.debounce(() => {
            // if (pathname !== APP_ROUTES.map) return;
            d(getDevicesCombined());
        }, DEBOUNCE_INTERVAL),
        [pathname, teamF, minifinderF],
    );

    return (message: SocketMessage) => {
        // console.log('message', message?.event, message?.action, moment().format('mm:ss.SSS'));
        switch (message?.event) {
            case 'positions':
                getDevicesWithThrottle();
                break;
            case 'notifications': {
                setTimeout(() => {
                    // d(getNotifications());
                }, 250);
                break;
            }
            default:
                console.log(`Unknown realtime message`, message);
        }

        switch (message?.action) {
            case 'sumulatePositions':
                getDevicesWithThrottle();
                break;
            case 'getNotifications':
                // d(getNotifications());
                break;
            case 'getBarkingDevices': {
                getDevicesWithThrottle();
                break;
            }

            case 'getPois': {
                // d(getAllPois());
                break;
            }
            case 'getGeofences': {
                // d(getAllGeofences());
                break;
            }
            case 'getDogGeofences': {
                // d(getAllGeofences());
                break;
            }
            default:
                break;
            // console.log(`Unknown action ${message}`)
        }
    };
};
